import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FornecedorService } from 'app/services/fornecedor.service';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-fornecedor-form',
  templateUrl: './fornecedor-form.component.html',
  styleUrls: ['./fornecedor-form.component.scss']
})
export class FornecedorFormComponent implements OnInit {
  public id_fornecedor: number;
  public nome: string;
  public cnpj: string;
  public telefone: string;
  public email: string;
  public endereco: string;
  public isLoading = false;
  public flg_status: number = 1; // Default to active

  public href;
  public contentHeader: object;
  private routeSub: Subscription;

  constructor(
    private route: ActivatedRoute,
    private fornecedorService: FornecedorService,
    private _router: Router
  ) { }

  ngOnInit() {
    this.href = this.route.url;

    if (this.href.value[1].path == "cadastro") {
      this.contentHeader = {
        headerTitle: "Cadastrar Fornecedor",
        actionButton: false,
        breadcrumb: {
          type: "",
          links: [
            { name: "Início", isLink: false },
            { name: "Fornecedor", isLink: false },
            { name: "Cadastrar", isLink: false }
          ]
        }
      };
    }

    if (this.href.value[1].path == "editar") {
      this.routeSub = this.route.params.subscribe(async (params) => {
        try {
          const fornecedor = await this.fornecedorService.getOne(params["id"]);
          
          this.id_fornecedor = params["id"];
          this.nome = fornecedor.nome;
          this.cnpj = fornecedor.cnpj;
          this.telefone = fornecedor.telefone;
          this.email = fornecedor.email;
          this.endereco = fornecedor.endereco;
          this.flg_status = fornecedor.flg_status || 1;
        } catch (error) {
          console.error('Erro ao carregar fornecedor:', error);
          Swal.fire({
            title: "Erro!",
            text: "Não foi possível carregar os dados do fornecedor.",
            icon: "error",
            confirmButtonText: "Ok"
          }).then(() => {
            this._router.navigate(['fornecedor']);
          });
        }
      });

      this.contentHeader = {
        headerTitle: "Editar Fornecedor",
        actionButton: false,
        breadcrumb: {
          type: "",
          links: [
            { name: "Início", isLink: false },
            { name: "Fornecedor", isLink: false },
            { name: "Editar", isLink: false }
          ]
        }
      };
    }
  }

  public async submitForm(form: NgForm) {
    if (form.form.valid) {
      this.isLoading = true;
      try {
        const isCreate = this.href.value[1].path === "cadastro";
        const message = isCreate ? "cadastrado" : "atualizado";
        
        const response = isCreate
          ? await this.fornecedorService.post(form.value)
          : await this.fornecedorService.patch(form.value, this.id_fornecedor);

        await Swal.fire({
          title: "Sucesso!",
          text: `O fornecedor foi ${message}.`,
          icon: "success",
          confirmButtonText: "Confirmar"
        });
        
        this._router.navigate(['fornecedor']);
      } catch (error) {
        console.error('Erro na operação:', error);
        await Swal.fire({
          title: "Erro!",
          text: "Ocorreu um erro ao processar a requisição.",
          icon: "error",
          confirmButtonText: "Ok"
        });
      } finally {
        this.isLoading = false;
      }
    }
  }

  ngOnDestroy() {
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }
}
